import type {Store} from 'redux';
import {selectEventDetailsValid} from '~/CreateFabricInvitation/reducers/details/selectors';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {
  CLEAR_PENDING_PHOTOS,
  TOGGLE_HOST_GALLERY_EDITOR_OPEN,
} from '~/ViewInvitation/reducers/constants';
import {selectHostUploadProcessing} from '~/ViewInvitation/selectors/photos';

export const validateEventDetails = async (
  store: Store,
  postValidate?: () => number | boolean,
  strict = false
) => {
  let valid = selectEventDetailsValid(store.getState(), strict);
  const postResult = postValidate?.() ?? true;
  valid = (typeof postResult === 'number' ? postResult === 0 : postResult) && valid;
  if (!valid) {
    store.dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {request: {failed: true}},
    });
    return false; // Prevent navigation
  }
  store.dispatch({
    type: UPDATE_EVENT_DETAILS,
    payload: {request: {failed: false}},
  });
  return true; // Allow navigation
};

// If Host Photos are processing, show a browser prompt to confirm choice to navigate
export const checkPhotoUploadStatus = async (store: Store, performCheck: boolean) => {
  const processing = selectHostUploadProcessing(store.getState());
  if (!processing || !performCheck) return true;

  if (
    // biome-ignore lint/suspicious/noAlert: We need to interrupt them to make sure they understand photos will stop uploading
    window.confirm(
      "Uploads are in progress. If you exit this page, remaining files won't be uploaded."
    )
  ) {
    store.dispatch({type: CLEAR_PENDING_PHOTOS});
    store.dispatch({type: TOGGLE_HOST_GALLERY_EDITOR_OPEN, payload: false});
    return true; // Navigate anyway
  }
  return false; // Stay on page
};
